export enum ProductType {
  NOVEL_CHAPTER = 'NOVEL_CHAPTER',
  MANGA_CHAPTER = 'MANGA_CHAPTER',
  DONATION = 'DONATION',
}
